export default __webpack_public_path__ + "static/media/kavita.e0a23875.PNG";